var _rect, _path, _path2, _path3, _path4, _path5, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreathing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    rx: 16,
    fill: "#f0fdfa"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200 70 L200 145",
    stroke: "#0d9488",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M200 90 C165 90 130 120 130 165 C130 210 165 230 200 220",
    fill: "#ccfbf1",
    stroke: "#0d9488",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M200 90 C235 90 270 120 270 165 C270 210 235 230 200 220",
    fill: "#ccfbf1",
    stroke: "#0d9488",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M200 100 C178 105 158 130 158 162",
    stroke: "#14b8a6",
    strokeWidth: 1.5,
    fill: "none",
    opacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M200 100 C222 105 242 130 242 162",
    stroke: "#14b8a6",
    strokeWidth: 1.5,
    fill: "none",
    opacity: 0.3
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 310,
    y: 92,
    fontFamily: "Arial",
    fontSize: 20,
    fontWeight: "bold",
    fill: "#0d9488",
    opacity: 0.35
  }, "O&#8322;")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 268,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 18,
    fontWeight: 700,
    fill: "#115e59"
  }, "Astim &amp; Solunum")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreathing);
export default __webpack_public_path__ + "static/media/breathing.52af4744e6b0d4aeaf4c535fc39b3418.svg";
export { ForwardRef as ReactComponent };